<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar
        class="defaultNav"
        :title="detailsInfo.projectName"
        left-text
        left-arrow
        ref="mtHeader"
        @click-left="back()"
      />
    </van-sticky>
    <van-tabs v-model="activeName">
      <van-tab title="Gallery" name="gallery">
        <div class="img-box">
          <el-image
            v-for="(item, index) in MediaData.img"
            :key="index"
            :src="imgUrl + item.url"
            @click="previewImgEmit(index)"
            :class="{
              'margin-left': (index - 0 + 1) % 2 == 0,
              'margin-top': index > 1
            }"
          >
            <div slot="error">
              Load Fail
            </div>
          </el-image>
        </div>
      </van-tab>
      <van-tab title="Virtual Tour" name="virtualTour">
        <div class="vir-wrap">
          <div
            class="vir-img-box"
            v-for="(item, index) in MediaData.ivt"
            :key="index"
            :class="{ 'margin-top': index >= 2, 'margin-top-ipad': index >= 1 }"
          >
            <img :src="imgUrl + item.url" alt="" />
            <span class="iconSpn" @click="goFileLink(item)"></span>
          </div>
        </div>
      </van-tab>
      <van-tab title="Video" name="video">
        <div class="vir-wrap">
          <div
            class="vir-img-box"
            v-for="(item, index) in MediaData.video"
            :key="index"
            :class="{ 'margin-top': index >= 2, 'margin-top-ipad': index >= 1 }"
          >
            <img :src="imgUrl + item.logoUrl" alt="" />
            <span class="VideoBtn" @click="gotoVideo(item)"></span>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="videoDIv" v-show="videoShow">
      <div class="video-box">
        <video
          id="video"
          class="videoDom"
          :src="imgUrl + videoUrl"
          controls
          preload="none"
          :poster="imgUrl + logoUrl"
        ></video>
        <span class="closeVideo" @click="closeVideo()">x</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gallery",
  data() {
    return {
      activeName: "Elevation",
      videoShow: false,
      videoUrl: "",
      logoUrl: "",
      img_suffix: "",
      defaultImgResize:
        "?x-oss-process=image/auto-orient,1/interlace,1/resize,p_70/quality,q_100"
    };
  },
  props: {
    detailsInfo: {},
    MediaData: {},
    imgUrl: "",
    activeMore: ""
  },
  mounted() {
    this.activeName = this.activeMore;
    this.querySysConfig();
  },
  methods: {
    querySysConfig() {
      this.$Post(this.$api.querySysConfig, {}).then(res => {
        if (res.code == 0) {
          this.img_suffix = res.datas.oss_img_resize;
        }
      });
    },
    back() {
      this.$emit("hideDetail", "showDetail");
    },
    goFileLink(item) {
      window.open(item.link);
    },
    gotoVideo(item) {
      let video = document.getElementById("video");
      this.videoUrl = item.url;
      this.logoUrl = item.logoUrl;
      this.videoShow = true;
      video.load();
    },
    closeVideo() {
      let videoElement = document.getElementById("video");
      videoElement.pause();
      this.videoShow = false;
    },
    previewImgEmit(index) {
      this.$emit("previewImg", this.MediaData.img, index);
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  .van-tabs {
    .van-tabs__wrap {
      position: fixed;
    }
    .van-tabs__content {
      .van-tab__pane {
        .img-box {
          padding: 3vh 0.2rem;
          overflow: auto;
          height: 80vh;
          .el-image {
            width: 1.62rem;
            height: 1.3rem;
            border-radius: 15px;
            .el-error {
              width: 100%;
              height: 100%;
              display: flex;
              vertical-align: middle;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #c0c4cc;
              background: #f5f7fa;
            }
          }
          .margin-left {
            margin-left: 0.1rem;
          }
          .margin-top {
            margin-top: 0.1rem;
          }
        }
        .vir-wrap {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 3vh 0.2rem;
          overflow: auto;
          height: 80vh;
          .vir-img-box {
            width: 1.62rem;
            height: 1.3rem;
            position: relative;
            img {
              width: 1.62rem;
              height: 1.3rem;
              border-radius: 15px;
            }
            .iconSpn {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 0.3rem;
              height: 0.3rem;
              display: inline-block;
              background: url("../../assets/img/virtual.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
            .VideoBtn {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 0.3rem;
              height: 0.3rem;
              display: inline-block;
              background: url("../../assets/img/video.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
  .videoDIv {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    .video-box {
      position: relative;
      #video {
        width: 3rem;
      }
      .closeVideo {
        position: absolute;
        top: 5px;
        right: 10px;
        color: #fff;
        cursor: pointer;
        font-size: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/shareMobile/galleryMore.vue